<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div class="messaging-description" data-cy="messaging-description-page">
    <cd-modal
        class="modal"
        title="Please Note"
        :large="true"
        :visible="isVerbalModalVisible"
        @close="isVerbalModalVisible = false"
        @confirm="handleVerbalModalConfirm"
    >
      <vwc-icon class="modal-icon" type="warning-line" />
      <p class="modal-text">
        {{ $t("smsRegistrations.messagingDescriptionModalText") }}
      </p>
    </cd-modal>
    <h5>{{ $t("smsRegistrations.messagingDescriptionHeader") }}</h5>
    <span class="description-sub-title">{{
      $t("smsRegistrations.messagingDescriptionSubHeader1")
    }}</span>
    <span>{{ $t("smsRegistrations.messagingDescriptionSubHeader2") }}</span>
    <messaging-description-check-box
        class="messaging-description-check-box"
        :tool-tip-info="toolTips[3]"
        :is-ack-checked="messagingDescriptionData.impliedCheckBox.isCheck"
        @checkBox="impliedCheckBoxChanged"
        :header="messagingDescriptionData.impliedCheckBox.header"
        :disabled="readOnly"
        data-cy="messaging-description-implied-check-box"
    >
      <div
          v-show="messagingDescriptionData.impliedCheckBox.isCheck"
          slot="messaging-description-check-box-body"
      >
        <div class="implied-consent">
          <span v-html="$t('smsRegistrations.messagingDescriptionImpliedConsentCheckBoxDescription')"/>
        </div>
      </div>
    </messaging-description-check-box>
    <messaging-description-check-box
      class="messaging-description-check-box"
      :tool-tip-info="toolTips[1]"
      :is-ack-checked="messagingDescriptionData.verbalCheckBox.isCheck"
      @checkBox="verbalCheckBoxChanged"
      :header="messagingDescriptionData.verbalCheckBox.header"
      :disabled="readOnly"
      data-cy="messaging-description-verbal-check-box"
    >
      <div
        v-show="messagingDescriptionData.verbalCheckBox.isCheck"
        slot="messaging-description-check-box-body"
      >
        <div class="verbal-sub-header">
          <span v-html="$t('smsRegistrations.messagingDescriptionVerbalCheckBoxDescriptionSubHeader')"></span>
        </div>
        <div class="verbal-text-area">
          <vwc-textarea
              required
              outlined
              dense
              class="verbal-message"
              :disabled="readOnly"
              :readOnly="
            !messagingDescriptionData.verbalCheckBox
              .verbalEditEnable
          "
              rows = 5
              @input="handleVerbalDescribe($event.target.value)"
              :value="
           messagingDescriptionData.verbalCheckBox.describe
          "
          />
          <vwc-icon-button
              @click="handleVerbalEdit"
              class="verbal-edit-icon"
              :disabled="readOnly || messagingDescriptionData.verbalCheckBox.verbalEditEnable"
              icon="edit-line"
          />
          <vwc-icon-button
              @click="handleVerbalReset"
              class="reset-icon"
              :disabled="readOnly || !messagingDescriptionData.verbalCheckBox.verbalEditEnable"
              icon="reset-line"
          />
        </div>
      </div>
    </messaging-description-check-box>
    <messaging-description-check-box
      class="messaging-description-check-box"
      :tool-tip-info="toolTips[2]"
      :is-ack-checked="messagingDescriptionData.paperCheckBox.isCheck"
      @checkBox="paperCheckBoxChanged"
      :header="messagingDescriptionData.paperCheckBox.header"
      :disabled="readOnly"
      data-cy="messaging-description-paper-check-box"
    >
      <div
        v-show="messagingDescriptionData.paperCheckBox.isCheck"
        slot="messaging-description-check-box-body"
      >
        <div class="all-steps-wrapper">
          <div class="paper-step-wrapper">
            <NumberOneSVG/>
            <div class="step-content">
              <span> {{ $t('smsRegistrations.messagingDescriptionPaperCheckBoxStep1') }}</span>
              <div class="disclaimer-note">
                <vwc-icon type="quote-line" class="privacy-icon"></vwc-icon>
                <span>{{ onlineAndPaperDisclaimer }}</span>
                <div>
                  <vwc-icon-button
                      connotation="cta"
                      @click="copy(onlineAndPaperDisclaimer)"
                      class="copy-icon-disclaimer"
                      icon="copy-2-line"
                  />
                </div>
              </div>
              <div class="info-note">
                <vwc-icon type="info-line" class="info-icon"></vwc-icon>
                <span>{{ $t('smsRegistrations.messagingDescriptionPaperCheckBoxStep1InfoNote') }}</span>
              </div>
            </div>
          </div>
          <div class="paper-step-wrapper">
            <NumberTwoSVG/>
            <div class="step-content">
              <span> {{ $t('smsRegistrations.messagingDescriptionPaperCheckBoxStep2') }}</span>
            </div>
          </div>
          <div class="paper-step-wrapper">
            <NumberThreeSVG/>
            <div class="step-content">
              <span> {{ $t('smsRegistrations.messagingDescriptionPaperCheckBoxStep3') }}</span>
            </div>
          </div>
          <div class="paper-step-wrapper">
            <NumberFourSVG/>
            <div class="step-content">
              <span> {{ $t('smsRegistrations.messagingDescriptionPaperCheckBoxStep4') }}</span>
              <text-field
                  :disabled="readOnly"
                  class="url-textField"
                  data-cy="description-paper-form-checkbox-url-input"
                  :validation-message="webSiteValidation(messagingDescriptionData.paperCheckBox.url)"
                  :pattern="regexPatterns.webSiteRegex"
                  @textChanged="messagingDescriptionData.paperCheckBox.url = $event"
                  :value="messagingDescriptionData.paperCheckBox.url"
                  :placeholder="
            $t(
              'smsRegistrations.messagingDescriptionOnlineCheckBoxUrlPlaceHolder'
            )
          "
              />
            </div>
          </div>
          <div class="paper-step-wrapper">
            <NumberFiveSVG/>
            <div class="step-content">
              <span> {{ $t('smsRegistrations.messagingDescriptionPaperCheckBoxStep5') }}</span>
              <text-field
                  :disabled="readOnly"
                  class="describe-text-field"
                  data-cy="description-paper-form-checkbox-input"
                  :char-counter = "true"
                  max-length="150"
                  @textChanged="
            messagingDescriptionData.paperCheckBox.describe = $event
          "
                  :value="messagingDescriptionData.paperCheckBox.describe"
                  :placeholder="
            $t(
              'smsRegistrations.messagingDescriptionPaperCheckBoxDescriptionPlaceHolder'
            )
          "
              />
            </div>
          </div>
        </div>
      </div>
    </messaging-description-check-box>
    <messaging-description-check-box
        class="messaging-description-check-box"
        :tool-tip-info="toolTips[0]"
        :is-ack-checked="messagingDescriptionData.onlineCheckBox.isCheck"
        @checkBox="onlineCheckBoxChanged"
        :header="messagingDescriptionData.onlineCheckBox.header"
        :disabled="readOnly"
        data-cy="messaging-description-online-check-box"
    >
      <div
          class="online-textFields-wrapper"
          v-show="messagingDescriptionData.onlineCheckBox.isCheck"
          slot="messaging-description-check-box-body"
      >
        <div class="all-steps-wrapper">
          <div class="paper-step-wrapper">
            <NumberOneSVG/>
            <div class="step-content">
              <span> {{ $t('smsRegistrations.messagingDescriptionOnlineCheckBoxStep1') }}</span>
            </div>
          </div>
          <div class="paper-step-wrapper">
            <NumberTwoSVG/>
            <div class="step-content">
              <span> {{ $t('smsRegistrations.messagingDescriptionOnlineCheckBoxStep2') }}</span>
              <div class="disclaimer-note">
                <vwc-icon type="quote-line" class="privacy-icon"></vwc-icon>
                <span>{{ onlineAndPaperDisclaimer }}</span>
                <div>
                  <vwc-icon-button
                      connotation="cta"
                      @click="copy(onlineAndPaperDisclaimer)"
                      class="copy-icon-disclaimer"
                      icon="copy-2-line"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="paper-step-wrapper">
            <NumberThreeSVG/>
            <div class="step-content">
              <span> {{ $t('smsRegistrations.messagingDescriptionOnlineCheckBoxStep3') }}</span>
            </div>
          </div>
          <div class="paper-step-wrapper">
            <NumberFourSVG/>
            <div class="step-content">
              <span> {{ $t('smsRegistrations.messagingDescriptionOnlineCheckBoxStep4') }}</span>
            </div>
          </div>
          <div class="paper-step-wrapper">
            <NumberFiveSVG/>
            <div class="step-content">
              <span> {{ $t('smsRegistrations.messagingDescriptionOnlineCheckBoxStep5') }}</span>
              <text-field
                  :disabled="readOnly"
                  class="url-textField"
                  data-cy="description-online-checkbox-url-input"
                  :validation-message="webSiteValidation(messagingDescriptionData.onlineCheckBox.url)"
                  :pattern="regexPatterns.webSiteRegex"
                  @textChanged="messagingDescriptionData.onlineCheckBox.url = $event"
                  :value="messagingDescriptionData.onlineCheckBox.url"
                  :placeholder="
            $t(
              'smsRegistrations.messagingDescriptionOnlineCheckBoxUrlPlaceHolder'
            )
          "
              />
            </div>
          </div>
          <div class="paper-step-wrapper">
            <NumberSixSVG/>
            <div class="step-content">
              <span> {{ $t('smsRegistrations.messagingDescriptionOnlineCheckBoxStep6') }}</span>
              <text-field
                  :disabled="readOnly"
                  class="describe-text-field"
                  data-cy="description-online-checkbox-description-input"
                  @textChanged="
            messagingDescriptionData.onlineCheckBox.describe = $event
          "
                  :value="messagingDescriptionData.onlineCheckBox.describe"
                  :char-counter="true"
                  max-length="150"
                  :placeholder="
            $t(
              'smsRegistrations.messagingDescriptionOnlineCheckBoxDescriptionPlaceHolder'
            )
          "
              />
            </div>
          </div>
        </div>
      </div>
    </messaging-description-check-box>
    <br>
    <div class="business-type-verification">
      <h5>SMS usage</h5>
      <div class="radio-options-container">
        <div v-for="option in businessTypeOptions" :key="option.value" class="radio-option">
          <VRadioGroup :disabled="readOnly" v-model="localBusinessType" :key="localBusinessType">
            <VRadio
                :id="'business-type-' + option.value"
                :ref="'businessType_' + option.value"
                :data-cy="`business-type-radio-${option.value}`"
                :value="option.value"
                :label="option.label"
            ></VRadio>
          </VRadioGroup>
          <div v-if="localBusinessType === option.value  && option.checkboxText" class="sms-usage-acknowledgment">
            <VCheckbox
                :disabled="readOnly"
                :label="option.checkboxText"
                v-model="isSmsAckChecked"
                :data-cy="`sms-usage-checkbox-${option.value}`"
            ></VCheckbox>
          </div>
        </div>
      </div>
    </div>
    <br>
    <div class="privacy-policy-div">
      <h5>Privacy Policy Verification</h5>
      <p class="description-sub-title">Does your business website include a Privacy Policy?</p>
      <div v-if="isBulkSms" class="privacy-radio-stack">
        <label class="privacy-native-radio-label">
          <input
            type="radio"
            name="privacyPolicyRadio"
            value="false"
            :checked="privacyRadio === 'false'"
            :disabled="readOnly"
            @change="privacyRadio = 'false'; privacyRadioDeclined($event)"
            data-cy="no-radio"
          />
          <span>No</span>
        </label>

        <div v-if="isBulkSms && privacyRadio === 'false'" class="privacy-checkbox-container">
          <VCheckbox
            :disabled="readOnly"
            v-model="privacyCheckbox"
            label="We acknowledge that the following disclosure is present upon obtaining customer opt in."
            data-cy="privacy-checkbox"
          ></VCheckbox>
          <div class="disclaimer-note">
            <vwc-icon type="quote-line" class="privacy-icon"></vwc-icon>
            <span>{{ privacyPolicyDisclaimer }}</span>
          </div>
        </div>

        <label class="privacy-native-radio-label">
          <input
            type="radio"
            name="privacyPolicyRadio"
            value="true"
            :checked="privacyRadio === 'true'"
            :disabled="readOnly"
            @change="privacyRadio = 'true'; privacyRadioAccepted($event)"
            data-cy="yes-radio"
          />
          <span>Yes</span>
        </label>
      </div>

      <div v-if="!isBulkSms">
        <VRadioGroup :disabled="readOnly" v-model="privacyRadio" orientation="vertical" class="privacy-radio">
          <VRadio label="No" value="false" @change="privacyRadioDeclined($event)" data-cy="no-radio"></VRadio>
          <VRadio label="Yes" value="true" @change="privacyRadioAccepted($event)" data-cy="yes-radio"></VRadio>
        </VRadioGroup>
      </div>
            

        <!-- ── Bulk SMS: Yes selected → show privacy policy URL input ── -->
        <div v-if="isBulkSms && privacyRadio === 'true'" class="privacy-checkbox-container">
          <label class="bsf-label" style="font-size:11px;font-weight:600;color:#555;text-transform:uppercase;letter-spacing:0.4px;">Privacy Policy Link</label>
          <p style="font-size:13px;color:#666;margin:4px 0 8px;">Provide a link to the Privacy Policy that covers how you collect and use customer data, including mobile phone numbers.</p>
          <text-field
            :disabled="readOnly"
            class="url-textField"
            style="max-width:100%;"
            data-cy="bulk-sms-privacy-policy-url-input"
            :validation-message="webSiteValidation(messagingDescriptionData.linkToPrivacyPolicy)"
            :pattern="regexPatterns.webSiteRegex"
            @textChanged="messagingDescriptionData.linkToPrivacyPolicy = $event"
            :value="messagingDescriptionData.linkToPrivacyPolicy"
            placeholder="https://"
            :char-counter="true"
            max-length="2048"
          />
        </div>

      <!-- ── Normal SMS registration (unchanged) ── -->
      <div v-if="!isBulkSms && privacyRadio === 'true'" class="privacy-checkbox-container">
        <VCheckbox
          :disabled="readOnly"
          v-model="privacyCheckbox"
          label="We acknowledge that the following disclosure is included in our Privacy Policy."
          data-cy="privacy-checkbox"
        ></VCheckbox>
        <div class="disclaimer-note">
          <vwc-icon type="quote-line" class="privacy-icon"></vwc-icon>
          <span>{{ privacyPolicyDisclaimer }}</span>
          <div>
            <vwc-icon-button
              connotation="cta"
              @click="copy(privacyPolicyDisclaimer)"
              class="copy-icon-disclaimer"
              icon="copy-2-line"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<!-- eslint-disable vue/no-mutating-props -->
<script>
import MessagingDescriptionCheckBox from "./MessagingDescriptionCheckBox";
import TextField from "../VwcTextField";
import CdModal from "../atomicUIComponents/modal/CdModal";
import {
  IMPLIED_CONSENT_DESCRIBE,
  OPT_IN_REGEX,
  WEBSITE_REGEX,
} from "../../helpers/constants";
import NumberOneSVG from "@/assets/NumberOneSVG.vue";
import NumberTwoSVG from "@/assets/NumberTwoSVG.vue";
import NumberThreeSVG from "@/assets/NumberThreeSVG.vue";
import NumberFourSVG from "@/assets/NumberFourSVG.vue";
import NumberFiveSVG from "@/assets/NumberFiveSVG.vue";
import NumberSixSVG from "@/assets/NumberSixSVG.vue";
import {
  VCheckbox,
  VRadio,
  VRadioGroup
} from "@vonage/vivid-vue";

export default {
  name: "MessagingDescription",
  components: {
    NumberSixSVG,
    NumberFiveSVG,
    NumberFourSVG,
    NumberThreeSVG,
    NumberTwoSVG,
    NumberOneSVG,
    CdModal,
    MessagingDescriptionCheckBox,
    TextField,
    VRadioGroup,
    VRadio,
    VCheckbox,
  },
  props: {
    readOnly: {
      type: Boolean,
      default: false,
    },
    companyName: {
      type: String,
      default: "",
    },
    companyUrl : {
      type: String,
      default: "",
    },
    messagingDescriptionData: {
      type: Object,
      default: () => ({}),
    },
    isBulkSms: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isVerbalModalVisible : false,
      regexPatterns: {
        webSiteRegex: WEBSITE_REGEX,
        optInRegex: OPT_IN_REGEX,
      },
      toolTips: [
        {
          id: "onlineToolTip",
          text: "Customers visit your website or application to subscribe or opt in to receive text messages.",
          icon: "help-line"
        },
        {
          id: "verbalToolTip",
          text: "Customers are verbally asked and provide their consent to receive text messages from your business",
          icon: "help-line"
        },
        {
          id: "paperToolTip",
          text: "Customers provide their consent to receive text messages when signing some paper form such as a contract, service agreement, etc.",
          icon: "help-line"
        },
        {
          id: "impliedToolTip",
          text: "Customers text an inquiry to your business number(s) and receive a reply.",
          icon: "help-line"
        },
      ],
      privacyRadio: "",
      privacyCheckbox: false,
      businessTypeOptions: [
        {
          value: 'INSURANCE_AGENCY',
          label: 'Insurance Agency/Broker',
          checkboxText: this.$t('smsRegistrations.businessTypeInsuranceText')
        },
        {
          value: 'RECRUITING_AGENCY',
          label: 'Recruiting',
          checkboxText: this.$t('smsRegistrations.businessTypeRecruitingText')
        },
        {
          value: 'FINANCIAL_AGENCY',
          label: 'Financial/Debt/Mortgage/Loan Agency',
          checkboxText: this.$t('smsRegistrations.businessTypeFinancialText')
        },
        {
          value: 'NOT_LISTED',
          label: 'None of the above'
        }
      ],
      localBusinessType: this.businessType,
      isSmsAckChecked: false
    };
  },
  beforeMount() {
    if ("hasPrivacyPolicy" in this.messagingDescriptionData) {
      this.privacyRadio = this.messagingDescriptionData.hasPrivacyPolicy ? "true" : "false";
      if (this.isBulkSms && !this.messagingDescriptionData.hasPrivacyPolicy) {
        this.privacyCheckbox = true;
      } else {
        this.privacyCheckbox = this.messagingDescriptionData.hasPrivacyPolicy;
      }
    }
    if ("businessType" in this.messagingDescriptionData) {
      this.$nextTick(() => {
        this.initBusinessType(this.messagingDescriptionData.businessType);
      });
    }
    // Forcing the override of the value loaded from the backend due to Product decision
    // this.messagingDescriptionData.verbalCheckBox.describe = this.messagingDescriptionData.verbalCheckBox.describe === "" ? this.verbalDisclaimer : this.messagingDescriptionData.verbalCheckBox.describe;
    this.messagingDescriptionData.verbalCheckBox.describe = this.verbalDisclaimer;
    this.messagingDescriptionData.impliedCheckBox.describe = IMPLIED_CONSENT_DESCRIBE;
    this.messagingDescriptionData.verbalCheckBox.url = this.companyUrl;
    this.messagingDescriptionData.impliedCheckBox.url = this.companyUrl;
    },
  computed: {
    messagingDescriptionValid() {
      const businessTypeValid = this.localBusinessType === 'NOT_LISTED' || (this.localBusinessType && this.isSmsAckChecked);
      if (this.privacyRadio === "") {
        return true;
      }
      if (!this.isBulkSms && this.privacyRadio === "true" && !this.privacyCheckbox) {
        return true;
      }
      if (this.isBulkSms && this.privacyRadio === "false" && !this.privacyCheckbox) {
        return true;
      }
      if (this.isBulkSms && this.privacyRadio === "true" &&
      (!this.messagingDescriptionData.linkToPrivacyPolicy ||
      !new RegExp(this.regexPatterns.webSiteRegex).test(this.messagingDescriptionData.linkToPrivacyPolicy))) {
        return true;
      }
      if (!businessTypeValid) {
        return true;
      }
      const checkedKeys = Object.keys(this.messagingDescriptionData).filter(
        (key) => this.messagingDescriptionData[key].isCheck
      );
      if (!checkedKeys.length) {
        return true;
      }
      const checkedValues = checkedKeys.map(
        (key) => this.messagingDescriptionData[key]
      );
      const checkedValuesEmptyInputs = checkedValues.map((checkBox) => {
        // Check if any value is an empty string
        const hasEmptyValue = Object.values(checkBox).some((value) => value === "");

        // If any value is empty, or if URL is invalid, return true
        if (hasEmptyValue || (checkBox.url && !new RegExp(this.regexPatterns.webSiteRegex).test(checkBox.url))) {
          return true;
        } else {
          return false;
        }
      });
      const allFieldsInCheckBoxNotEmpty =
        checkedValuesEmptyInputs.every((value) => value === false);

      return (
        !allFieldsInCheckBoxNotEmpty
      );
    },
    onlineAndPaperDisclaimer() {
      return `By checking this box you agree to receive recurring messages from ${this.companyName}, Reply STOP to Opt out. Reply HELP for help. Message frequency varies. Message and data rates may apply. Carriers are not liable for delayed or undelivered messages. No mobile information will be shared with third parties/affiliates for marketing/promotional purposes. All OPT-IN requests include text messaging originator opt-in data and consent; this information will not be shared with third parties.`
    },
    verbalDisclaimer() {
      return `Agent: Do you agree to receive text messages from ${this.companyName}? Message frequency varies. Message and data rates may apply.  Reply STOP to opt out and HELP for help. No mobile information will be shared with third parties or affiliates for marketing or promotional purposes. All OPT-IN requests include text messaging originator opt-in data and consent; this information will not be shared with third parties.\n` +
          `Customer: Yes`
    },
    privacyPolicyDisclaimer() {
      return 'No mobile information will be shared with third parties/affiliates for marketing/promotional purposes. All OPT-IN requests include text messaging originator opt-in data and consent; this information will not be shared with third parties.';
    },
  },
  methods: {
    onlineCheckBoxChanged(val) {
      this.messagingDescriptionData.onlineCheckBox.isCheck = val;
    },
    verbalCheckBoxChanged(val) {
      this.messagingDescriptionData.verbalCheckBox.isCheck = val;
    },
    paperCheckBoxChanged(val) {
      this.messagingDescriptionData.paperCheckBox.isCheck = val;
    },
    impliedCheckBoxChanged(val) {
      this.messagingDescriptionData.impliedCheckBox.isCheck = val;
    },
    privacyRadioDeclined(event) {
      if (this.isCheckedFromEvent(event)) {
        this.messagingDescriptionData.hasPrivacyPolicy = false;
      }
    },
    privacyRadioAccepted(event) {
      if (this.isCheckedFromEvent(event)) {
        this.messagingDescriptionData.hasPrivacyPolicy = true;
      }
    },
    isCheckedFromEvent(event) {
      return event.srcElement.checked;
    },
    handleVerbalEdit() {
      this.isVerbalModalVisible = true;
    },
    handleVerbalModalConfirm() {
      this.isVerbalModalVisible = false;
      this.messagingDescriptionData.verbalCheckBox.verbalEditEnable = true;
    },
    handleVerbalReset() {
      this.messagingDescriptionData.verbalCheckBox.verbalEditEnable = false;
      this.messagingDescriptionData.verbalCheckBox.describe =
          this.verbalDisclaimer;
    },
    handleVerbalDescribe(value) {
      this.messagingDescriptionData.verbalCheckBox.describe =
          value?.trim();
    },
    webSiteValidation(url) {
      if (!url) {
        return this.$t("smsRegistrations.requiredField");
      }
      if (url.length > 100) {
        return this.$t("smsRegistrations.websiteTooLong");
      }
      const linkToTermsAndConditions = this.messagingDescriptionData.linkToTermsAndConditions;
      if (!/^https?:\/\//.test(linkToTermsAndConditions)) {
        return this.$t("smsRegistrations.webSiteHttpLead");
      }

      return this.$t("smsRegistrations.invalidWebsite");
    },
    copy(val) {
      const tempInput = document.createElement("textarea");
      tempInput.value = val;
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand("copy");
      document.body.removeChild(tempInput);
      this.$refs.copiedToClipboardSnackbar.show();
    },
    initBusinessType(value) {
      if (typeof value === 'undefined' || value === null) {
        return;
      }
      this.localBusinessType = value;
      this.$nextTick(() => {
        this.isSmsAckChecked = true;
        this.$emit('businessType', value)
      });
    },
  },
  watch: {
    localBusinessType: {
      handler(newVal) {
        this.isSmsAckChecked = false;
        this.messagingDescriptionData.businessType = newVal;
      },
    },
    messagingDescriptionValid: {
      immediate: true,
      handler() {
        this.$emit("pageValidityChange", !this.messagingDescriptionValid);
      },
    },
  },
};
</script>

<style scoped>
.description-sub-title {
  font-weight: bold;
}
.messaging-description {
  margin: 24px 24px 8px;
}
.online-textFields-wrapper {
  display: flex;
  flex-direction: column;
}
.url-textField {
  margin-top: 4px;
  max-width: 50%;
}
.url-links {
  display: flex;
}
.input-link-to-privacy {
  margin-right: 15px;
}
.optIn-keyword {
  max-width: 20%;
}
.text-to-join-down {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.optIn-message {
  width: 100%;
  margin-right: 28px;
}
.edit-icon {
  cursor: pointer;
}
.reset-icon {
  cursor: pointer;
}
.modal-text {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
}
.modal-icon {
  position: absolute;
  top: 23px;
  left: 155px;
}
.checkbox-with-text {
  display: flex;
  flex-direction: row;
  gap: 8px;
}
.verbal-sub-header {
  margin-top: 12px;
  margin-bottom: 8px;
  display: flex;
  flex-direction: column;
}
.verbal-message {
  width: 100%;
  margin-right: 16px;
}
.verbal-text-area {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  padding-bottom: 16px;
}
.paper-step-wrapper {
  display: flex;
  gap: 16px;
  margin-bottom: 8px;
}
.step-content{
  display: flex;
  flex-direction: column;
  width: 100%;
}
.disclaimer-note {
  padding: 20px;
  border-radius: 8px;
  background: #F2F2F2;
  border: 1px solid #757575;
  display: flex;
  margin-top:8px;
  gap: 16px;
}

.copy-icon-disclaimer {
  --vvd-icon-button-icon-size: 32px;
  --mdc-icon-size: 32px;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

.info-note {
  padding: 20px;
  border-radius: 8px;
  background: #E8F4FB;
  border: 1px solid #0276D5;
  display: flex;
  margin-top:8px;
  gap : 16px;
}

.info-icon {
  color: #0276D5;
}

.all-steps-wrapper {
  flex-direction: column;
  display: flex;
  gap: 12px;
  margin-top: 12px;
}

.all-steps-wrapper .paper-step-wrapper:last-child {
  margin-top: -16px;
  margin-bottom: -4px;
}

.describe-text-field {
  padding: 4px 0px 0px !important;
}

.implied-consent {
  margin-top: 16px;
  margin-bottom: 16px;
}

.privacy-checkbox-container {
  margin-left: 30px;
}

.privacy-icon {
  color: #9E9E9E;
  flex-shrink: 0;
  width: 20px;
  height: 20px;
}

.radio-option {
  margin-bottom: 10px;
}

.radio-wrapper vwc-radio {
  align-items: center;
  margin-right: 10px;
}

.sms-usage-acknowledgment {
  display: flex;
  margin-left: 32px;
}

.sms-usage-acknowledgment span {
  margin-top: 8px;
}

.messaging-description-check-box {
  padding: 24px;
}

.privacy-policy-div {
  margin-bottom: 24px;
}

/* ADD: */
.privacy-radio-stack {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 8px;
}

.privacy-native-radio-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #1b1b1b;
  cursor: pointer;
}

.privacy-native-radio-label input[type="radio"] {
  width: 16px;
  height: 16px;
  accent-color: black;
  cursor: pointer;
}


</style>
